export class ImagesPreloader {
    static async preloadImages(urls) {
        return new Promise(async (res, rej) => {
            const toBeLoadedNumber = urls.length;
            for (let i = 0; i < toBeLoadedNumber; i++) {
                const url = urls[i];
                await ImagesPreloader._preloadImage(url);
            }

            res();
        })
    }

    static async _preloadImage(url) {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.src = url;
        });
    }
}

